module.exports = __webpack_public_path__ + "img/view_1.48294782.svg";